export default "__VITE_ASSET__ChRf$Sm5__"